<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('stockConfirm.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockConfirm.pageTitle'),
            href: '/admin/stock-confirm'
          },
          {
            text: $t('stockConfirm.confirm'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div
            class="ts-border ts-border-blue-300 ts-p-3 ts-rounded"
            v-if="!isAvailableShow"
          >
            <form class="form-horizontal">
              <div class="row">
                <div class="col-md-4">
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.branch') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none"
                        type="text"
                        :value="edit_data.branch.branch_name_en"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.location') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none"
                        type="text"
                        :value="edit_data.location.location_name_en"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.supplier') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none"
                        type="text"
                        :value="
                          edit_data.supplier
                            ? edit_data.supplier.vendor_name
                            : null
                        "
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.stockInDate') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none"
                        type="text"
                        :value="edit_data.stock_in_date"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.invoiceNo') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none ts-text-blue-500 ts-font-extrabold"
                        type="text"
                        :value="edit_data.invoice_no"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.poNumber') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none ts-text-blue-500 ts-font-extrabold"
                        type="text"
                        :value="
                          edit_data.purchase_order
                            ? edit_data.purchase_order.po_number
                            : null
                        "
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.stockInNumber') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none ts-text-red-600 ts-font-extrabold"
                        type="text"
                        :value="edit_data.stock_in_number"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.createdBy') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none ts-font-extrabold"
                        type="text"
                        :value="edit_data.user.name"
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div
            class="ts-border ts-border-gray-300 ts-p-3 ts-rounded ts-mt-3 max-h"
            v-if="!isAvailableShow"
          >
            <SearchBox v-model="model" :placeholder="$t('search')" />
            <br />
            <table class="ts-w-full ts-overflow-scroll ts-mt-3">
              <thead>
                <tr>
                  <th
                    class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-16 ts-text-center"
                  >
                    {{ $t('stockConfirm.no') }}
                  </th>
                  <th
                    class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-40"
                  >
                    {{ $t('stockConfirm.barcode') }}
                  </th>
                  <th
                    class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
                  >
                    {{ $t('stockConfirm.productName') }}
                  </th>
                  <th
                    class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-40 ts-text-center"
                  >
                    {{ $t('stockConfirm.uom') }}
                  </th>
                  <th
                    class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-40 ts-text-center"
                  >
                    {{ $t('stockConfirm.quantity') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in resources"
                  :key="index"
                  class="ts-border-b ts-border-gray-300"
                >
                  <td class="ts-px-2 ts-py-1 ts-text-center">
                    {{ index + 1 }}
                  </td>
                  <td class="ts-px-2 ts-py-1">{{ item.barcode }}</td>
                  <td class="ts-px-2 ts-py-1">{{ item.product_name_en }}</td>
                  <td class="ts-px-2 ts-py-1 ts-text-center">
                    {{ item.uom_name_en }}
                  </td>
                  <td class="ts-px-2 ts-py-1 ts-text-center ts-text-red-600">
                    <strong>{{ item.quantity }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div class="row">
            <div class="col-md-4">
              <label>{{ $t('stockConfirm.remark') }}</label>
              <textarea
                v-model.trim="dataSend.remarks"
                rows="3"
                class="form-control"
              ></textarea>
            </div>
          </div>
          <div class="ts-flex ts-space-x-3 ts-mt-3 ts-justify-end">
            <ts-button
              @click.prevent="() => $router.push({ name: 'stock-confirm' })"
              >{{ $t('cancel') }}</ts-button
            >
            <ts-button
              color="primary"
              :waiting="waiting"
              @click.prevent="onConfirm"
              :disabled="isAlreadyConfirm"
              >{{ $t('stockConfirm.confirm') }}</ts-button
            >
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
    <a-modal
      v-if="show_modal_confirm"
      v-model="show_modal_confirm"
      :title="$t('stockTransfer.are_you_sure_to_confirm')"
      :centered="true"
      :maskClosable="false"
      :okText="$t('confirm')"
      :zIndex="1020"
      :confirmLoading="confirming"
      width="300px"
      @ok="onConfirm"
      @cancel="onCanel"
    >
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('stockTransfer.confirmDate')
              }}</label>
              <div>
                <a-date-picker
                  class="ts-w-full"
                  :allowClear="false"
                  v-model="received_date"
                  format="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  :disabled-date="disabledDate"
                />
                <div class="validate" v-if="errors.has('received_date')">
                  {{ errors.first('received_date') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SearchBox from './components/search-box.vue'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'viewStockInConfirm',
  components: {
    SearchBox
  },
  data() {
    return {
      waiting: false,
      confirming: false,
      show_serial: false,
      show_modal_confirm: false,
      status_id: 1,
      datasource: [],
      received_date: null,
      errors: new Errors(),
      loading: false,
      dataSend: {
        remarks: null,
        stock_in_id: null
      },
      model: {
        search_value: ''
      }
    }
  },
  computed: {
    ...mapState('stock/stockInConfirm', ['edit_data']),
    resources: vm => {
      return vm.edit_data.stock_in_details.filter(
        p =>
          p.barcode
            .toLowerCase()
            .includes(vm.model.search_value.toLowerCase()) ||
          p.product_name_en
            .toLowerCase()
            .includes(vm.model.search_value.toLowerCase()) ||
          p.uom_name_en
            .toLowerCase()
            .includes(vm.model.search_value.toLowerCase())
      )
    },
    isAvailableShow() {
      return _.isEmpty(this.edit_data)
    },
    isAlreadyConfirm() {
      if (!_.isEmpty(this.edit_data)) {
        return this.edit_data.is_confirm_stock
      }
      return false
    }
  },
  methods: {
    ...mapActions('stock/stockInConfirm', ['find', 'confirm']),
    async fetchData() {
      this.loading = true
      await this.find(this.$route.params.id)
      this.dataSend.stock_in_id = this.edit_data.stock_in_id
      this.dataSend.remarks = this.edit_data.remarks

      // Set received_date to stock_in_date (transfer date) by default
      if (this.edit_data.stock_in_date) {
        this.received_date = this.edit_data.stock_in_date
      }

      this.loading = false
    },
    disabledDate(current) {
      if (!this.edit_data.stock_in_date) {
        return true // Disable all dates if no stock_in_date
      }

      const transferDate = moment(this.edit_data.stock_in_date, 'DD-MM-YYYY')
      const today = moment().endOf('day')
      const currentDate = moment(current)

      // Allow dates between transfer_date and today (inclusive)
      // Disable dates before transfer_date or after today
      return (
        currentDate.isBefore(transferDate, 'day') ||
        currentDate.isAfter(today, 'day')
      )
    },
    async checkReceiveMonthDiffMonthTransfer(data) {
      try {
        let response = await this.$store.dispatch(
          'stock/stockInConfirm/checkReceiveMonthDiffMonthTransfer',
          data
        )
        if (response) {
          this.confirming = false
          if (
            await this.$confirmModal.danger(
              '<span class="text-primary">Month of confirm date and transfer date are different.</span><br /><br />' +
                'Transfer Date: <span class="text-success ts-font-bold">' +
                this.edit_data.stock_in_date +
                '</span><br />Confirm Date: <span class="text-success ts-font-bold">' +
                this.received_date +
                '</span><br /> <br /> <span class="ts-font-bold text-warning">Are you sure to confirm?</span>'
            )
          ) {
            return true
          } else {
            return false
          }
        }
        return true
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
        this.confirming = false
        return false
      }
    },
    // Show modal first instead of directly confirming
    async onConfirm() {
      if (!this.show_modal_confirm) {
        // First click - show the modal
        this.show_modal_confirm = true
        return
      }

      // Validate received_date is selected
      if (!this.received_date) {
        this.errors = new Errors({
          received_date: ['Confirm date is required']
        })
        return
      }

      // Second click (from modal OK button) - proceed with confirmation
      this.errors = new Errors()
      this.confirming = true

      if (
        await this.checkReceiveMonthDiffMonthTransfer({
          stock_in_id: this.edit_data.stock_in_id,
          received_date: this.received_date,
          transfer_date: this.edit_data.stock_in_date
        })
      ) {
        this.confirm({
          stock_in_id: this.edit_data.stock_in_id,
          received_date: this.received_date,
          remarks: this.dataSend.remarks
        })
          .then(response => {
            this.confirming = false
            this.show_modal_confirm = false
            this.$toasted.success(response.message)
            this.$router.push({ name: 'stock-confirm' })
          })
          .catch(error => {
            if (
              error.message ===
                'The current user not yet belong to any warehouses.' ||
              error.message ===
                'Transferred and received user must be different.'
            ) {
              this.$toasted.info(error.message)
            } else {
              this.$toasted.error(error.message)
            }
            this.errors = new Errors(error.errors)
            this.confirming = false
          })
      }
    },
    onCanel() {
      this.show_modal_confirm = false
      this.confirming = false
      this.errors = new Errors()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/stockInConfirm/SET_EDIT_DATA', [])
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
<style scoped>
/* .max-h {
	min-height: 50vh;
  max-height: 60vh;
} */
table {
  /* white-space: nowrap; */
  margin: 0;
  /* border-collapse: separate; */
  border-spacing: 0;
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}
</style>
